<template>
  <div v-if="currentCTA && showCTA">
    <InsightsCTABanner
      :type="currentCTA.type"
      :is-loading="isLoading"
      :hide-action-button="isManager && currentCTA.type === 'upgrade'"
      @showDialog="toggleDialog"
      @submit="submitCTA"
      @close="hideCTA"
    />
    <InsightsCTABannerDialog
      v-if="showDialog"
      :show="showDialog"
      :type="currentCTA.type"
      @close="toggleDialog(false)"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InsightsCTABanner from '~/components/insights/InsightsCTABanner.vue';

export default {
  name: 'InsightsCTA',
  components: {
    InsightsCTABanner,
    InsightsCTABannerDialog: () => import('~/components/insights/InsightsCTABannerDialog.vue'),
  },
  data: () => ({
    showCTA: true,
    showDialog: false,
    isLoading: false,
  }),
  computed: {
    ...mapGetters([
      'billingUrl',
      'monitoringAddonEnabled',
      'planOkForAppTracking',
      'appTrackingUsed',
      'canManageSettings',
      'isManager',
    ]),
    ctas() {
      return [
        {
          type: 'upgrade',
          localStorageHiddenKey: 'insightsMonitoringCTAUpgradeHidden',
          visible: this.canManageSettings && !this.planOkForAppTracking,
          url: this.billingUrl,
        },
        {
          type: 'enable',
          localStorageHiddenKey: 'insightsMonitoringCTAEnableHidden',
          visible:
            this.canManageSettings &&
            this.planOkForAppTracking &&
            (!this.monitoringAddonEnabled || !this.appTrackingUsed),
        },
      ];
    },
    currentCTA() {
      return this.ctas.find((cta) => cta.visible && !localStorage.getItem(cta.localStorageHiddenKey));
    },
  },
  methods: {
    ...mapActions(['enableMonitoringURLs', 'enableAppsAndURLs']),
    hideCTA(setLocalstorage) {
      if (setLocalstorage) {
        localStorage.setItem(this.currentCTA.localStorageHiddenKey, true);
      }
      this.showCTA = false;
    },
    toggleDialog(val) {
      this.showDialog = val;
    },
    async submitCTA() {
      this.isLoading = true;

      if (this.currentCTA.url) {
        window.location.href = this.currentCTA.url;

        return;
      }
      if (!this.monitoringAddonEnabled) {
        try {
          // Enable monitoring addon
          await this.enableMonitoringURLs({
            params: { addons: { monitor_user_activity: 1 } },
          });

          const appsAndUrlsSettingsParams = [
            { setting: 'client_app_and_url_tracking', value: 2 },
            { setting: 'client_screenshot_frequency', value: 0 },
            { setting: 'monitor_user_activity', value: 0 },
          ];

          // The BE requires this params to be sent in a specific order synchronously
          for (const params of appsAndUrlsSettingsParams) {
            await this.enableAppsAndURLs({ params });
          }

          this.$appMessage("Apps & URLs' settings have been successfully applied!");

          setTimeout(() => {
            window.location.reload();
          }, 500);
        } catch (e) {
          this.$appMessage(e);
        }
        this.isLoading = false;
      }
      if (this.monitoringAddonEnabled && !this.appTrackingUsed) {
        try {
          await this.enableAppsAndURLs({
            params: { setting: 'client_app_and_url_tracking', value: 2 },
          });

          this.$appMessage("Apps & URLs' settings have been successfully applied!");

          setTimeout(() => {
            window.location.reload();
          }, 500);

          this.isLoading = false;
        } catch (e) {
          this.$appMessage(e);
        }
      }
    },
  },
};
</script>
